import { Color, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'

import { VatDeclarationsReportPart } from '@features/vatDeclarations/types/vatDeclarationsReportPart'
import { VatDeclarationsReportSection as VatDeclarationsReportSectionType } from '@features/vatDeclarations/types/vatDeclarationsReportSection'

import { Table } from '../Table'
import * as Styled from './styles'

interface SectionProps {
  reportSegment: VatDeclarationsReportSectionType | VatDeclarationsReportPart
}

export const Section = ({ reportSegment }: SectionProps): ReactElement => {
  const renderReportSegments = useCallback(() => {
    if ('sections' in reportSegment) {
      return reportSegment.sections.map((reportSection) => (
        <Table
          reportSection={reportSection}
          key={reportSection?.symbol ? `${reportSection?.symbol}-${reportSection?.name}` : reportSection.name}
        />
      ))
    } else if ('fields' in reportSegment) {
      return <Table reportSection={reportSegment} showTitle={false} />
    }
  }, [reportSegment])

  return (
    <>
      <Styled.SectionRow>
        <Text color={Color.White} weight="bold">
          {reportSegment.name}
        </Text>
      </Styled.SectionRow>
      {renderReportSegments()}
    </>
  )
}
